import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

interface PpmPhotosContextValue {
  pendingOperations: number;
  addPending: () => void;
  removePending: () => void;
}

const PpmPhotosContext = createContext<PpmPhotosContextValue | null>(null);

export function PpmPhotosProvider({ children }: { children: React.ReactNode }) {
  const [pendingOperations, setPendingOperations] = useState(0);

  const addPending = useCallback(() => {
    setPendingOperations((prev) => prev + 1);
  }, []);

  const removePending = useCallback(() => {
    setPendingOperations((prev) => Math.max(0, prev - 1));
  }, []);

  // Safety net on unmount
  useEffect(() => {
    return () => setPendingOperations(0);
  }, []);

  return (
    <PpmPhotosContext.Provider value={{ pendingOperations, addPending, removePending }}>
      {children}
    </PpmPhotosContext.Provider>
  );
}

export function usePpmPhotosContext() {
  const context = useContext(PpmPhotosContext);
  if (!context) {
    throw new Error("usePpmPhotosContext must be used within a PpmPhotosProvider");
  }
  return context;
}
